import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";

export const markAllAsRead = async (props: { token: string }) => {
  const url = `${END_POINT.BASE_URL}/v1/notifications/mark-all-as-read`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const response = await axios.post(url, {}, config);
  return response;
};

export const useMarkAllNotificationsRead = () => {
  return useMutation(markAllAsRead);
};
